import React, { useState } from 'react';
import './tooltip.css';

const Tooltip = ({ children, content, position = 'top', className = '' }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className='tooltip-container' onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
            {children}
            {visible && <div className={`tooltip-box ${position} ${className}`}>{content}</div>}
        </div>
    );
};

export default Tooltip;
